import React from "react";
import { Flavor } from "./flavor";
import { color2 } from "src/styles";
import { LogoVanilla } from "src/components/LogoVanilla";

class VanillaFlavor extends Flavor {
  getMainColor() {
    return color2.MORRISONS;
  }

  getCircleLogo() {
    return <LogoVanilla />;
  }

  getFeatureFlags() {
    return {
      ...super.getFeatureFlags(),
      isAddressEnabled: true,
      hideProcessTime: true,
      aifiFooterText: false,
    };
  }
}

const Singleton = new VanillaFlavor();
export default Singleton;
